import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function TimelineVertical({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#timeline_vertical)">
        <path
          d="M2.88867 1.55469V6.44358"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.88867 14.4436V9.55469"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5553 2H7.77756C7.28664 2 6.88867 2.39797 6.88867 2.88889V5.55556C6.88867 6.04648 7.28664 6.44444 7.77756 6.44444H13.5553C14.0463 6.44444 14.4442 6.04648 14.4442 5.55556V2.88889C14.4442 2.39797 14.0463 2 13.5553 2Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.88905 9.55642C3.74816 9.55642 4.44461 8.85998 4.44461 8.00087C4.44461 7.14176 3.74816 6.44531 2.88905 6.44531C2.02994 6.44531 1.3335 7.14176 1.3335 8.00087C1.3335 8.85998 2.02994 9.55642 2.88905 9.55642Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5553 9.55469H7.77756C7.28664 9.55469 6.88867 9.95266 6.88867 10.4436V13.1102C6.88867 13.6012 7.28664 13.9991 7.77756 13.9991H13.5553C14.0463 13.9991 14.4442 13.6012 14.4442 13.1102V10.4436C14.4442 9.95266 14.0463 9.55469 13.5553 9.55469Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="timeline_vertical">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
